import React, { useEffect, useState } from "react";

import Layout from "../components/shared/Layout";
import OrganizationsTable from "../components/ManageAccount/OrganizationsTable";
import UsersTable from "../components/ManageAccount/UsersTable";

export default function ManageAccount() {
  return (
    <Layout>
      <div className="row">
        <div className="col s12 m6">
          <OrganizationsTable />
        </div>
        <div className="col s12 m6">
          <UsersTable />
        </div>
      </div>
    </Layout>
  );
}
